<template>
  <div v-if="task">
    <task-body
      :task="task"
      :try-join="tryJoin"
      :try-leave="tryLeave"
      :joined="joinBtnState"
      :join-pending="joinPending"
      :global-rules="globalRules"
      :user-left="userLeft"
      :user-rejected="userRejected"
      :rejected-reason="rejectedReason"
      :participant="participant"
    />
    <box>
      <h3 class="mb-5">{{ $tc('reward', 2) }}</h3>
      <div class="mb-1">
        <masonry :cols="{ default: 3, 1200: 2, 992: 1 }" :gutter="20">
          <reward
            v-if="task.rewardFollow"
            class="mb-4"
            :title="$filters.capitalize($tc('follow', 1))"
            disabled-limits
            header-class="instagram-color"
            :icon="getIcon(task.type, 'follow')"
            :metric-title="$tc('follower', 2)"
            :value="task.rewardFollow"
          />
          <reward
            v-if="task.rewardDescription"
            class="mb-4"
            :title="$filters.capitalize($tc('description', 1))"
            header-class="instagram-color"
            :icon="getIcon(task.type, 'description')"
            :metric-title="$tc('follower', 2)"
            :value="task.rewardDescription"
          >
            <div
              v-if="rewardRules.rewardDescription.length"
              class="mt-2"
              slot="bottom"
            >
              <h6 class="pb-0 col-form-label text-uppercase">
                {{ $tc('rule', 2) }}
              </h6>
              <div
                v-for="rule in rewardRules.rewardDescription"
                :key="rule.name"
              >
                <span class="text-lighten">{{ rule.name }}:</span>
                {{ rule.value }}
              </div>
            </div>
          </reward>
          <reward
            v-if="task.rewardPost"
            class="mb-4"
            :title="$filters.capitalize($tc('post', 1))"
            header-class="instagram-color"
            :icon="getIcon(task.type, 'post')"
            :metric-title="$tc('follower', 2)"
            :value="task.rewardPost"
          >
            <div
              v-if="rewardRules.rewardPost.length"
              class="mt-2"
              slot="bottom"
            >
              <h6 class="pb-0 col-form-label text-uppercase">
                {{ $tc('rule', 2) }}
              </h6>
              <div v-for="rule in rewardRules.rewardPost" :key="rule.name">
                <span class="text-lighten">{{ rule.name }}:</span>
                {{ rule.value }}
              </div>
            </div>
          </reward>
          <!-- <reward
            v-if="task.rewardStory"
            class="mb-4"
            :title="$filters.capitalize($tc('story', 1))"
            header-class="instagram-color"
            :icon="getIcon(task.type, 'story')"
            :metric-title="$tc('follower', 2)"
            :value="task.rewardStory"
          >
            <div class="mt-2" slot="bottom">
              <h6 class="pb-0 col-form-label text-uppercase">{{ $tc('rule', 2) }}</h6>
              {{ task.rewardStoryd.params }}
            </div>
          </reward> -->
          <reward
            v-if="task.rewardComment"
            class="mb-4"
            :title="$filters.capitalize($tc('comment', 1))"
            header-class="instagram-color"
            :icon="getIcon(task.type, 'comment')"
            :metric-title="$tc('follower', 2)"
            :value="task.rewardComment"
          >
            <div
              v-if="rewardRules.rewardComment.length"
              class="mt-2"
              slot="bottom"
            >
              <h6 class="pb-0 col-form-label text-uppercase">
                {{ $tc('rule', 2) }}
              </h6>
              <div v-for="rule in rewardRules.rewardComment" :key="rule.name">
                <span class="text-lighten">{{ rule.name }}:</span>
                {{ rule.value }}
              </div>
            </div>
          </reward>
          <reward
            v-if="task.rewardLike"
            class="mb-4"
            :title="$filters.capitalize($tc('like', 1))"
            header-class="instagram-color"
            :icon="getIcon(task.type, 'like')"
            :metric-title="$tc('follower', 2)"
            :value="task.rewardLike"
          >
            <div
              v-if="rewardRules.rewardLike.length"
              class="mt-2"
              slot="bottom"
            >
              <h6 class="pb-0 col-form-label text-uppercase">
                {{ $tc('rule', 2) }}
              </h6>
              <div v-for="rule in rewardRules.rewardLike" :key="rule.name">
                <span class="text-lighten">{{ rule.name }}:</span>
                {{ rule.value }}
              </div>
            </div>
          </reward>
        </masonry>
      </div>
    </box>
  </div>
</template>

<script>
import taskMixin from './../../mixins/task.js';
import RewardsList from '@/views/Campaign/BountyCampaign/components/RewardsList.vue';

export default {
  mixins: [taskMixin],

  components: {
    RewardsList
  },

  computed: {
    rewardRules() {
      return {
        rewardDescription: [
          {
            name: this.$t('hashTagsMustAdd'),
            value:
              this.task.rewardDescription &&
              this.task.rewardDescription.params.hashtags
                ? ['', ...this.task.rewardDescription.params.hashtags].join(
                    ' #'
                  )
                : null
          },
          {
            name: this.$t('profileTagsMustAdd'),
            value:
              this.task.rewardDescription &&
              this.task.rewardDescription.params.profiletags
                ? ['', ...this.task.rewardDescription.params.profiletags].join(
                    ' @'
                  )
                : null
          },
          {
            name: this.$t('linkInBio'),
            value:
              this.task.rewardDescription &&
              this.task.rewardDescription.params.linkbio
          },
          {
            name: this.$t('minCharWithTags'),
            value:
              this.task.rewardDescription &&
              this.task.rewardDescription.params.minLength
          }
        ].filter(el => el.value),
        rewardPost: [
          {
            name: this.$t('hashTagsMustAdd'),
            value:
              this.task.rewardPost && this.task.rewardPost.params.hashtags
                ? ['', ...this.task.rewardPost.params.hashtags].join(' #')
                : null
          },
          {
            name: this.$t('profileTagsMustAdd'),
            value:
              this.task.rewardPost && this.task.rewardPost.params.profiletags
                ? ['', ...this.task.rewardPost.params.profiletags].join(' @')
                : null
          },
          {
            name: this.$t('minCharWithTags'),
            value: this.task.rewardPost && this.task.rewardPost.params.minLength
          }
        ].filter(el => el.value),
        rewardComment: [
          {
            name: this.$t('hashTagsMustAdd'),
            value:
              this.task.rewardComment && this.task.rewardComment.params.hashtags
                ? ['', ...this.task.rewardComment.params.hashtags].join(' #')
                : null
          },
          {
            name: this.$t('profileTagsMustAdd'),
            value:
              this.task.rewardComment &&
              this.task.rewardComment.params.profiletags
                ? ['', ...this.task.rewardComment.params.profiletags].join(' @')
                : null
          },
          {
            name: this.$t('minCharWithTags'),
            value:
              this.task.rewardComment &&
              this.task.rewardComment.params.minLength
          },
          {
            name: this.$t('maxPostAgeDays'),
            value:
              this.task.rewardComment &&
              this.task.rewardComment.params.maxPostAge
                ? `${this.task.rewardComment.params.maxPostAge} days`
                : null
          }
        ].filter(el => el.value),
        rewardLike: [
          {
            name: this.$t('maxPostAgeDays'),
            value:
              this.task.rewardLike && this.task.rewardLike.params.maxPostAge
                ? `${this.task.rewardLike.params.maxPostAge} days`
                : null
          }
        ].filter(el => el.value)
      };
    },
    globalRules() {
      return [
        {
          name: this.$t('minFollowers'),
          value: this.task.minFollowers
        },
        {
          name: this.$t('minAmountOfPosts'),
          value: this.task.minPostsCount
        }
      ];
    }
  },

  methods: {
    tryJoin() {
      const socialNetworks = this.$store.state.app.user.socialNetworks || {};

      if (!socialNetworks.instagram) {
        this.$notify('alert', {
          text: this.$t('connectNetworks.connectInstagramAtFirst'),
          variant: 'danger',
          time: 0
        });
        return;
      }
      this.join();
    }
  }
};
</script>
